import React, { useState } from 'react';

const AddCertificationModal = ({ isOpen, onClose, onCertificationAdded }) => {
  const [formData, setFormData] = useState({
    name: '',
    issuingOrganization: '',
    issueDate: '',
    expiryDate: '',
    credentialId: '',
    credentialUrl: '',
    description: ''
  });
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.issuingOrganization.trim()) {
      setError('Certification name and issuing organization are required');
      return;
    }
    setError('');
    onCertificationAdded(formData);
    onClose();
    setFormData({
      name: '',
      issuingOrganization: '',
      issueDate: '',
      expiryDate: '',
      credentialId: '',
      credentialUrl: '',
      description: ''
    });
  };

  const handleClose = () => {
    setError('');
    onClose();
    setFormData({
      name: '',
      issuingOrganization: '',
      issueDate: '',
      expiryDate: '',
      credentialId: '',
      credentialUrl: '',
      description: ''
    });
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Add Certification</h2>
          <button onClick={handleClose} className="modal-close">×</button>
        </div>
        <form onSubmit={handleSubmit} className="modal-body">
          {error && <div className="error-message">{error}</div>}
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Certification Name *</label>
              <input type="text" value={formData.name} onChange={e => setFormData({...formData, name: e.target.value})} className="input-field" required />
            </div>
            <div className="form-group">
              <label className="form-label">Issuing Organization *</label>
              <input type="text" value={formData.issuingOrganization} onChange={e => setFormData({...formData, issuingOrganization: e.target.value})} className="input-field" required />
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Issue Date</label>
              <input type="date" value={formData.issueDate} onChange={e => setFormData({...formData, issueDate: e.target.value})} className="input-field" />
            </div>
            <div className="form-group">
              <label className="form-label">Expiry Date</label>
              <input type="date" value={formData.expiryDate} onChange={e => setFormData({...formData, expiryDate: e.target.value})} className="input-field" />
            </div>
          </div>
          <div className="form-grid">
            <div className="form-group">
              <label className="form-label">Credential ID</label>
              <input type="text" value={formData.credentialId} onChange={e => setFormData({...formData, credentialId: e.target.value})} className="input-field" />
            </div>
            <div className="form-group">
              <label className="form-label">Credential URL</label>
              <input type="url" value={formData.credentialUrl} onChange={e => setFormData({...formData, credentialUrl: e.target.value})} className="input-field" />
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} rows={3} className="input-field textarea-field" />
          </div>
          <div className="modal-actions">
            <button type="button" onClick={handleClose} className="btn btn-secondary">Cancel</button>
            <button type="submit" className="btn btn-primary">Add Certification</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddCertificationModal; 